"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONSTS = {
  MAX_WAIT_TIME: 50,
  SEEK_WAIT_TIME: 200
};

exports["default"] = CONSTS;
module.exports = exports["default"];